import { FC } from 'react';
import { IconType } from './icon-types';

interface BrowserLogoDto {
  browser: string;
  path: string;
  iconType: IconType;
}

const browserLogos: BrowserLogoDto[] = [
  {
    browser: 'Chrome',
    iconType: IconType.IMAGE,
    path: '/media/logos/chrome-logo.png'
  },
  {
    browser: 'Edge',
    iconType: IconType.IMAGE,
    path: '/media/logos/edge-logo.png'
  },
  {
    browser: 'Facebook',
    iconType: IconType.IMAGE,
    path: '/media/logos/facebook-logo.png'
  },
  {
    browser: 'Firefox',
    iconType: IconType.IMAGE,
    path: '/media/logos/firefox-logo.png'
  },
  {
    browser: 'Internet Explorer',
    iconType: IconType.IMAGE,
    path: '/media/logos/ie-logo.png'
  },
  {
    browser: 'Opera',
    iconType: IconType.IMAGE,
    path: '/media/logos/opera-logo.png'
  },
  {
    browser: 'Safari',
    iconType: IconType.IMAGE,
    path: '/media/logos/safari-logo.png'
  },
  {
    browser: 'Samsung',
    iconType: IconType.IMAGE,
    path: '/media/logos/samsung-logo.png'
  }
];

const BrowserLogo: FC<{
  browser: string;
  imageClasses?: string;
  iconClasses?: string;
}> = ({
  browser,
  imageClasses,
  iconClasses
}: {
  browser: string;
  imageClasses?: string;
  iconClasses?: string;
}) => {
  const logoToUse = browserLogos.find((logo) => browser.includes(logo.browser));

  return logoToUse ? (
    <>
      {logoToUse.iconType === IconType.FLATICON ? (
        <i className={`${logoToUse.path} ${iconClasses}`}></i>
      ) : (
        <img
          src={logoToUse.path}
          className={imageClasses}
          alt={logoToUse.browser}
        />
      )}
    </>
  ) : (
    <></>
  );
};

export default BrowserLogo;
